var getters = {}

export default getters
